;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreTableColumnRowCountLabel', tableColumnRowCountLabel)

  /* @ngInject */
  function tableColumnRowCountLabel () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        label: '<'
      },
      templateUrl: '/core/directives/table-columns/table-column-row-count-label/table-column-row-count-label-directive.html?$$REVISION$$'
    }
  }
})()
